import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var defaultProps = {};
var styleOverrides = {
  root: function root(_ref) {
    var _LumaContainerPati;
    var theme = _ref.theme;
    return {
      '& .MuiLink-root': {
        color: theme.palette.secondary.main,
        '&:hover': {
          textDecoration: 'underline'
        }
      },
      '& .LumaContainerPatientFormLaunch-root': (_LumaContainerPati = {
        padding: theme.spacing(0, 4)
      }, _defineProperty(_LumaContainerPati, theme.breakpoints.down('md'), {
        padding: theme.spacing(0, 1)
      }), _defineProperty(_LumaContainerPati, theme.breakpoints.down('sm'), {
        padding: 0
      }), _LumaContainerPati),
      // Hide the wave hand icon from the header
      '& .MuiTypography-h2 > .MuiSvgIcon-root': {
        display: 'none'
      }
    };
  }
};
export default {
  defaultProps: defaultProps,
  styleOverrides: styleOverrides
};